import axios from "axios";
import constants from "common/utils/constants";
import { useDebugValue } from "react";
import showLogoutConfirmation from "CommonComponents/LogOutModal";

const axiosClient = axios.create();
let logoutPopupShown = false;

axiosClient.defaults.baseURL = constants.HOST_URL;

axiosClient.defaults.headers = constants.headers;

// To share cookies to cross site domain, change to true.
axiosClient.defaults.withCredentials = false;

axiosClient.interceptors.request.use(function (config) {
  var token = localStorage.getItem("token_bearer");
  var token_type = localStorage.getItem("token_type");
  var authHeader = `${token_type} ${token}`;
  var selectedCompanyId = localStorage.getItem("CompanyId");
  config.headers.Authorization = authHeader;
  config.headers.CompanyId = selectedCompanyId;
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status == 401) {
      if (!logoutPopupShown) {
        logoutPopupShown = true;
        const lastVisitedPath = localStorage.getItem("lastVisitedPath");
        const selectedCompany = localStorage.getItem("CompanyId");
        showLogoutConfirmation({
          type: "warning",
          title: "Session Timeout",
          content:
            "Your login session has expired. Please log in again to continue using the application.",
          onConfirm: () => {
            logoutPopupShown = false;
            localStorage.clear();
            window.location.reload(true);
            if (lastVisitedPath) {
              localStorage.setItem("lastVisitedPath", lastVisitedPath);
              localStorage.setItem("CompanyId", parseInt(selectedCompany));
            }
          },
        });
      }
      return Promise.resolve();
    }
    return Promise.reject(error);
  }
);

export function getRequest(URL, config = {}) {
  return axiosClient.get(`/${URL}`, config).then((response) => response);
}

export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}

export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`).then((response) => response);
}
